import { render, staticRenderFns } from "./PackEdit.vue?vue&type=template&id=cefb6de2&scoped=true&"
import script from "./PackEdit.vue?vue&type=script&lang=js&"
export * from "./PackEdit.vue?vue&type=script&lang=js&"
import style0 from "./PackEdit.vue?vue&type=style&index=0&id=cefb6de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefb6de2",
  null
  
)

export default component.exports